<a *ngIf="selectedStage" href="#" class="dropdown-toggle" data-toggle="dropdown" >
  <span>{{ selectedStage.name }}</span>
</a>
<ul class="stage-picker dropdown-menu">
  <li *ngFor="let stage of stages" [ngClass]="{'hidden': stage._id === selectedStage?._id}">
    <a href="javascript:void(0)" (click)="changeSelectedStage(stage)">{{ stage.name }}</a>
  </li>
</ul>
